import { Link } from "@tanstack/react-router";
import { Instagram, Facebook, Youtube } from "lucide-react";
import { XLogo } from "@/components/site/icons/XLogo";
import { LanguageSwitcher } from "@/components/site/LanguageSwitcher";

export function TopBar() {
  return (
    <nav aria-label="Utility" className="hidden md:block border-b border-border/60 bg-brand-soft/40">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-2 text-xs tracking-wide">
        <div className="flex items-center gap-6">
          <a href="tel:7037099771" aria-label="Call Virginia Bariatric Surgery at 703-709-9771" className="font-medium text-brand-deep hover:text-brand-deep">(703) 709-9771</a>
          <a href="https://vbportal.pattrax.com" target="_blank" rel="noopener noreferrer" className="text-brand-deep hover:underline">Patient Portal</a>
          <Link to="/contact" className="text-brand-deep hover:underline">Contact</Link>
          <LanguageSwitcher className="text-brand-deep hover:underline" />

        </div>
        <div className="flex items-center gap-6">
          <a href="https://www.youtube.com/@virginiabariatricsurgeryce114" target="_blank" rel="noopener noreferrer" aria-label="Visit Virginia Bariatric Surgery on YouTube" className="inline-flex items-center gap-1 text-brand-deep hover:underline">
            <Youtube size={14} aria-hidden="true" />
            YouTube
          </a>
          <a href="https://www.instagram.com/doctorfitzer/" target="_blank" rel="noopener noreferrer" aria-label="Follow Dr. Matthew Fitzer on Instagram" className="inline-flex items-center gap-1 text-brand-deep hover:underline">
            <Instagram size={14} aria-hidden="true" />
            Instagram
          </a>
          <a href="https://www.facebook.com/virginiabariatric/" target="_blank" rel="noopener noreferrer" aria-label="Visit Virginia Bariatric Surgery on Facebook" className="inline-flex items-center gap-1 text-brand-deep hover:underline">
            <Facebook size={14} aria-hidden="true" />
            Facebook
          </a>
          <a href="https://x.com/vbariatric" target="_blank" rel="noopener noreferrer" aria-label="Follow Virginia Bariatric on X (Twitter)" className="inline-flex items-center text-brand-deep hover:underline">
            <XLogo size={15} />
          </a>
          <a href="https://vbportal.pattrax.com/events" target="_blank" rel="noopener noreferrer" className="text-brand-deep hover:underline">Webinar Schedule</a>
          <Link to="/appointments" className="font-medium text-brand-deep hover:underline">Appointments</Link>
        </div>
      </div>
    </nav>
  );
}
